import { useEffect, useState } from "react";
import { GiGraveyard } from "react-icons/gi";

import { useAuth } from "../../../../shared/hooks/useAuth";
import { useSearchSideBarCemetery } from "../../../../shared/hooks/useSideBar";

import { RoundedButton } from "../../../global";
import { useToggle } from "../../../../shared/hooks/useToggle";
import { FeaturesEnum } from "../../../../shared/enums/features.enum";

export const SearchMenuCemetery: React.FC = () => {
    const { setShouldOpen, shouldOpen } = useSearchSideBarCemetery();
    const { user } = useAuth();
    const { isActive, toggle } = useToggle();

    const [canSearch, setCanSearch] = useState<boolean>(false);

    const toggleLayersSideBarStatus = () => {
        setShouldOpen(!shouldOpen);
        toggle();
    };

    useEffect(() => {
        const allowedActions =
            user.authorizationsByFeatureName[FeaturesEnum.CEMETERY_SEARCH]
                ?.featureAllowedActions;

        setCanSearch(
            allowedActions
                ? allowedActions.includes("read") || allowedActions === "*"
                : false
        );
    }, [user]);

    useEffect(() => {
        if (!shouldOpen && isActive) toggle();
    }, [shouldOpen, isActive, toggle]);

    if (!canSearch) return null;

    return (
        <RoundedButton
            onClick={toggleLayersSideBarStatus}
            description="BUSCA CEMITÉRIO"
            active={isActive}
        >
            <GiGraveyard size={40} className="inline-block" />
        </RoundedButton>
    );
};
